import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-notifications',
  templateUrl: './tutorial-notifications.component.html',
  styleUrls: ['./tutorial-notifications.component.css']
})
export class TutorialNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}